import React from "react";
import { Modal } from "../../components/Modal";
import classnames from "classnames";
import "./styles.less";

export const CardModal = (props) => {
  const { setVisible, imgUrl, cardTitle, cardText } = props;
  return (
    <Modal
      className={classnames("card-modal", props.className)}
      {...{ visible: props.visible }}
    >
      <i
        onClick={() => setVisible(false)}
        className="icon authing-icon authing-guanbi"
      />
      <div className="card-modal-title">
        <img src={imgUrl} alt="authing icon" />
      </div>
      <div className="card-modal-body">
        <div className="card-modal-body-title">{cardTitle}</div>
        <div className="card-modal-body-text">{cardText}</div>
      </div>
    </Modal>
  );
};
